import React, { createContext, useContext, useEffect, useRef } from "react";
import useWebSocket from "react-use-websocket";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { WS_ENDPOINT_URL } from "configs/AppConfig";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const JWT_TOKEN = localStorage.getItem(AUTH_TOKEN);
  const { sendMessage, lastMessage, readyState } = useWebSocket('wss://app.expresswebs.ca/ws/', {
    protocols: JWT_TOKEN ? [JWT_TOKEN]: [], // ✅ Send JWT for authentication
    shouldReconnect: () => true, // ✅ Auto-reconnect
  });

  // Send a ping every 2 minutes
  const pingInterval = useRef(null);
  useEffect(() => {
    if (readyState === 1) {
      console.log("✅ WebSocket Connected");
      pingInterval.current = setInterval(() => {
        sendMessage(JSON.stringify({ type: "ping" }));
        console.log("📡 Sending Ping");
      }, 120000);
    }
    return () => clearInterval(pingInterval.current);
  }, [readyState]);

  return (
    <WebSocketContext.Provider value={{ sendMessage, lastMessage, readyState }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);